import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import { ConfigModal } from "../ConfigAdmin/ConfigAdmin";
import { rouletteAdminContext } from "../../../context/Admin/RouletteAdminContext/RouletteAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { convertDate, numberSeparate } from "../../../utils";

const RouletteAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    rouletteItems,
    roulette,
    totalCount,
    pageNumber,
    setPageNumber,
    limit,
    setLimit,
    id,
    thumbnail,
    setThumbnail,
    title,
    setTitle,
    description,
    setDescription,
    count,
    setCount,
    weight,
    setWeight,
    isShowModal,
    isShowDetailsModal,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetRouletteItemList,
    handleCreateRouletteItem,
    handleEditRouletteItem,
    handleDeleteRouletteItem,
  } = useContext(rouletteAdminContext);

  useEffect(() => {
    handleGetRouletteItemList();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="آیتم های گردونه" />

      <CardLayout>
        <a className="btn btn-outline-info mb-3" href={`${process.env.PUBLIC_URL}/docs/roulette-fa.html`}
          target="_blank" rel="noopener noreferrer">راهنمای راه‌اندازی و مدیریت گردونه</a>
        {permission.roulette_items_create && (
          <div className="mb-2">
            <button
              className="btn btn-success mr-2"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
            <ConfigModal
              title="تنظیمات گردونه"
              configTypes={[
                "ROULETTE_DESCRIPTION",
                "ROULETTE_TITLE",
                "ROULETTE",
                "ROULETTE_SPIN_LIMIT",
              ]}
            />
          </div>
        )}
        {isEmpty(rouletteItems) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  <th>تصویر</th>
                  <th>عنوان</th>
                  <th>تعداد</th>
                  <th>وزن</th>
                  <th>توضیحات</th>
                  <th>تاریخ ایجاد</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rouletteItems.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.id}</td>
                    <td>
                      {" "}
                      <img
                        src={_item.thumbnail}
                        alt={_item.thumbnail}
                        className="img-fluid img-thumbnail rounded"
                        width={50}
                      />
                    </td>
                    <td>{_item.title}</td>
                    <td>{numberSeparate(_item.count)}</td>
                    <td>{numberSeparate(_item.weight)}</td>
                    <td>{_item.description}</td>
                    <td>{convertDate(_item.created)}</td>
                    <td className="mw-25">
                      {/* <button
                        onClick={() => handleShowDetailsModal(_item)}
                        className="btn btn-info mr-2"
                      >
                        جزئیات
                      </button> */}
                      {permission.roulette_items_update && (
                        <button
                          onClick={() => handleShowModal(_item)}
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      {permission.roulette_items_delete && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteRouletteItem(_item.id),
                              `آیا از حذف آیتم گردونه ${_item.id} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} آیتم گردونه`}
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <form
          onSubmit={id ? handleEditRouletteItem : handleCreateRouletteItem}
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="title">عنوان</label>
              <input
                type="text"
                id="title"
                name="title"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="thumbnail">تصویر</label>
              <input
                type="text"
                id="thumbnail"
                name="thumbnail"
                className="form-control"
                value={thumbnail}
                onChange={(e) => setThumbnail(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="count">تعداد</label>
              <input
                type="number"
                id="count"
                min="0"
                step="1"
                name="count"
                className="form-control"
                value={count}
                onChange={(e) => setCount(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="weight">وزن (شانس نسبی دریافت جایزه)</label>
              <input
                type="number"
                id="weight"
                min="0"
                max="65535"
                step="1"
                name="weight"
                className="form-control"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
              />
              <small className="text-muted">وزن درصد نیست؛ با صفر کردن وزن یا موجودی، جایزه از قرعه‌کشی خارج می‌شود.</small>
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
          <hr />
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات آیتم گردونه"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{roulette.id}</p>
            </ItemInfo>
            <ItemInfo label="عنوان">
              <p>{roulette.title}</p>
            </ItemInfo>
            <ItemInfo label="تصویر">
              <p>{roulette.thumbnail}</p>
            </ItemInfo>
            <ItemInfo label="تعداد">
              <p>{roulette.count}</p>
            </ItemInfo>
            <ItemInfo label="وزن">
              <p>{roulette.weight}</p>
            </ItemInfo>
            <ItemInfo label="توضیحات">
              <p className="pre_wrap-white_space">{roulette.description}</p>
            </ItemInfo>
            <ItemInfo label="پیشنمایش تصویر">
              <p className="text-center">
                <img
                  src={roulette.thumbnail}
                  alt={roulette.title}
                  className="img-fluid img-thumbnail rounded"
                />
              </p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default RouletteAdmin;
